<template>
  <div>
    <el-form
      class="mt-2"
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      label-width="100px"
      label-position="left"
    >
      <div>
        <el-form-item
          :label="$l('form_label_fabricScmName') || '店铺名称'"
          prop="resFabricScmName"
        >
          <el-input
            v-model="formData.resFabricScmName"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            maxlength="50"
            clearable
            size="small"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item
          :label="$l('form_label_fabricScmAddress') || '店铺地址'"
          prop="resFabricScmAddress"
        >
          <el-input
            v-model="formData.resFabricScmAddress"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            maxlength="50"
            clearable
            size="small"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <StroeContactTable
      ref="stroeContactTable"
      :tableData="formData.scmContactList"
      :disabled="disabled"
    />

    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>

    <StoreImage
      :disabled="disabled"
      :resFabricScmCode="resFabricScmCode"
      :resFabricRecordCode="resFabricRecordCode"
      @reloadScm="reloadScm"
      :title="$l('form_label_image_maintenance') || '图片维护'"
      @reload="loadData"
    />
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import StroeContactTable from '../stroe-contact-table'
import StoreImage from '../store-image'
export default {
  mixins: [EditLoading],
  components: {
    StroeContactTable,
    StoreImage,
  },
  props: {
    disabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    resFabricScmCode: { type: String, default: '' },
    resFabricRecordCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      imageVisible: true,
      rules: {},
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {},
  methods: {
    async loadData() {
      if (!this.resFabricScmCode) return
      this.loadingOpen()
      const res = await this.$api
        .resFabricScmPcDetailApi({
          resFabricScmCode: this.resFabricScmCode,
        })
        .catch(() => {})
      this.loadingClose()
      this.formData = res.body || {}
    },
    async save() {
      if (!(await this.validate())) return

      const scmContactList = await this.$refs.stroeContactTable.getTableData()
      const params = {
        resFabricScmCode: this.resFabricScmCode,
        ...this.formData,
        scmContactList,
      }
      this.loadingOpen()
      const res = await this.$api
        .resFabricScmPcEditSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
    },
    async validate() {
      const formValidate = await validate.formValidate([this.$refs.form])
      const techTableValidate = await this.$refs.stroeContactTable.validate()
      return formValidate && techTableValidate
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    reloadScm() {},
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}

.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}

::v-deep {
  .el-form {
    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
    > div {
      border: 1px solid #ebeef5;
      border-top: none;

      > .el-form-item {
        margin: 0 !important;
        position: relative;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 8px 10px;
          border-right: 1px solid #ebeef5;
          font-size: 12px !important;
          position: absolute;
          bottom: 0;
          top: 0;
          display: flex;
          align-items: center;
        }

        .el-form-item__content {
          padding: 0 10px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;

          > div {
            margin: 3.2px 0;
          }
        }
      }
    }
  }
}
</style>
